import React from "react";
import Globalize from "globalize";
import { merge, $ } from "glamor";
import classNames from "classnames";
import NuORDERIcon from "components/icons/nuorder";
import IconButton from "material-ui/IconButton";
import PinIcon from "components/icons/pin";
import CloseIcon from "material-ui/svg-icons/navigation/chevron-left";
import OpenIcon from "material-ui/svg-icons/navigation/chevron-right";
import { DATATEST } from "constants/integration";

let styles;
const getStyles = () => {
    if (!styles) {
        styles = merge(
            {
                textAlign: "left",
                margin: "0 0 2px",
                fontSize: "14px",
                overflow: "hidden",
                transition: "all .15s ease-in-out",
                height: "60px",
                position: "relative",
                width: "100%",
                flexShrink: 0,
            },
            $(".mobile", {
                height: "56px",
                paddingBottom: "8px",
            }),
            $(" > .icon", {
                position: "absolute",
                fill: "rgba(255,255,255,.8) !important",
                top: "50%",
                left: "18px",
                transform: "translate(0, -50%)",
                transition: "all .15s ease-in-out",
            }),
            $(".tablet > .icon", {
                opacity: 0,
            }),
            $(".tablet.isPinned > .icon", {
                opacity: 1,
            }),
            $(" > div", {
                paddingLeft: "60px",
                textAlign: "left",
            }),
            $(" .footerTitle", {
                color: "rgba(255,255,255,.9)",
                fontSize: "12px",
                lineHeight: "14px",
                paddingTop: "16px",
            }),
            $(" .actions", {
                lineHeight: "12px",
            }),
            $(" .actions > a", {
                color: "rgba(255,255,255,.7)",
                textDecoration: "underline",
                margin: "0 8px 0 0",
                padding: "0px",
                display: "inline-block",
                fontSize: "10px",
                lineHeight: "12px",
            }),
            $(" .actions > a:hover", {
                color: "rgba(255,255,255,1)",
            }),
            $(" .toggleNav", {
                position: "absolute !important",
                left: "192px",
                transform: "translate(0, -50%)",
            }),
            $(".tablet .toggleNav", {
                left: "8px",
            }),
            $(".tablet.isPinned .toggleNav", {
                left: "192px",
            }),
        );
    }
    return styles;
};

const Footer = ({ isPinned, onTogglePin, isMobile = false, touchDevice }) => {
    let toggleButton;
    if (isPinned) {
        toggleButton = <CloseIcon />;
    } else if (touchDevice) {
        toggleButton = <OpenIcon />;
    } else {
        toggleButton = <PinIcon />;
    }

    return (
        <div
            className={classNames({
                isPinned,
                tablet: !isMobile && touchDevice,
                mobile: isMobile && touchDevice,
            })}
            {...getStyles()}
        >
            <NuORDERIcon className="icon" />
            <div>
                <div className="footerTitle">© Lightspeed NuORDER Inc.</div>
                <div className="actions">
                    <a
                        data-test={DATATEST.NAV.PRIVACY}
                        key="privacy"
                        href="https://www.nuorder.com/privacypolicy/"
                        target="_blank"
                    >
                        {Globalize.formatMessage("Privacy")}
                    </a>
                    <a
                        data-test={DATATEST.NAV.TERMS}
                        key="terms"
                        href="https://www.nuorder.com/termsandconditions/"
                        target="_blank"
                    >
                        {Globalize.formatMessage("Terms")}
                    </a>
                    <a
                        data-test={DATATEST.NAV.HELP_DESK}
                        key="help"
                        href="https://helpdesk.nuorder.com/hc/en-us"
                        target="_blank"
                    >
                        {Globalize.formatMessage("Help")}
                    </a>
                </div>
            </div>
            {!isMobile && (
                <IconButton
                    data-test={DATATEST.NAV.PIN}
                    className="toggleNav"
                    iconStyle={{ fill: "rgba(255,255,255,.8)" }}
                    onClick={onTogglePin}
                >
                    {toggleButton}
                </IconButton>
            )}
        </div>
    );
};

export default Footer;
